<template>
  <div class="modal fade" id="modalChangeWs" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Alterar fase extraordinaria e tipo de remuneração</h4>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>extraordinaryPhase</label>
              <input v-model="dataChange.extraordinaryPhase" type="number" class="form-control"
                     name="extraordinaryPhase" placeholder="extraordinaryPhase" required>
              <span v-if="dataError.errorExtraordinaryPhase"
                    class="error-msg">{{ dataError.errorExtraordinaryPhase }}</span>
            </div>
            <div class="example-enum">
              <p>Exemplos:</p>
              <p>0 - Nenhum</p>
              <p>1 - Feriado</p>
              <p>2 - Domingo</p>
              <p>3 - Domingo e Feriado</p>
            </div>

            <div class="form-group">
              <label>remunerateType</label>
              <input v-model="dataChange.remunerateType" type="number" class="form-control" name="remunerateType"
                     placeholder="remunerateType" required>
              <span v-if="dataError.errorRemunerateType" class="error-msg">{{ dataError.errorRemunerateType }}</span>
            </div>
            <div class="example-enum">
              <p>Exemplos:</p>
              <p>0 - Nenhum</p>
              <p>1 - Compensação</p>
              <p>2 - Hora extra</p>
              <p>3 - Banco de horas</p>
            </div>

            <div class="form-group">
              <label>toleranceType</label>
              <input v-model="dataChange.toleranceType" type="number" class="form-control" name="toleranceType"
                     placeholder="toleranceType" required>
              <span v-if="dataError.errorToleranceType" class="error-msg">{{ dataError.errorToleranceType }}</span>
            </div>
            <div class="example-enum">
              <p>Exemplos:</p>
              <p>0 - Não aplicar</p>
              <p>1 - Cada registro</p>
              <p>2 - Acumulada no dia</p>
              <p>3 - Cada registro e acumulada no dia</p>
              <p>4 - Youtility</p>
              <p>5 - Primeiro ponto e último</p>
            </div>

            <div v-if="wsMass" class="form-group">
              <input-select col="" :options="trueOrFalse" :value-selected="false"
                            label="Habilitar Ignorar Deconto de Horas Faltantes em Dias de Falta"
                            @selectedOption="value => dataChange.ignoreMissingHoursOnFault = value"/>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button v-on:click="handleChange()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  UPDATE_WS_D, UPDATE_WS_D_MASS
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import InputSelect from "../components/inputs/inputSelect.vue";

export default {
  name: "modalChangeWs",
  components: {InputSelect},
  props: ['wsSelected', 'wsMass'],
  data() {
    return {
      modalContext: '',
      trueOrFalse: [
        {
          id: false,
          name: 'Não'
        },
        {
          id: true,
          name: 'Sim'
        }
      ],
      dataChange: {
        workShiftId: null,
        extraordinaryPhase: null,
        remunerateType: null,
        toleranceType: null,
      },
      dataError: {
        errorExtraordinaryPhase: null,
        errorRemunerateType: null,
        errorToleranceType: null
      },
      setValueToReload: null,
      loadingChange: false,
      dataWorkshiftMass: null,
    }
  },
  watch: {
    wsSelected: function (val) {
      this.dataChange = {
        workShiftId: null,
        extraordinaryPhase: null,
        remunerateType: null,
        toleranceType: null,
      }
      if (!this.$props.wsMass) {
        this.dataChange.workShiftId = val.id;
        this.dataChange.extraordinaryPhase = val.extraordinaryPhase;
        this.dataChange.remunerateType = val.remunerateType;
        this.dataChange.toleranceType = val.toleranceType;
        this.modalContext = val.context;
      }
    },
    wsMass: function (val) {
      this.dataChange = {
        workShiftId: null,
        extraordinaryPhase: null,
        remunerateType: null,
        toleranceType: null,
      }
      if (!this.$props.wsSelected) {
        this.dataWorkshiftMass = val;
      }
    },
    setValueToReload: function (val) {
      this.$emit('update:reloadPage', val)
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:reloadPage', Math.floor(Math.random() * 100) - 110)
      $('#modalChangeWs').modal('toggle');
    },
    changeWs() {
      this.dataError.errorExtraordinaryPhase = "";
      this.dataError.errorRemunerateType = "";
      this.dataError.errorToleranceType = "";

      if (this.dataChange.extraordinaryPhase !== null && this.dataChange.remunerateType !== null && this.dataChange.toleranceType !== null) {
        this.loadingChange = true;
        UTIL_SERVICE.console("DATA SEND:", this.dataChange);
        REQUEST_SERVICE.requestContext('PUT', UPDATE_WS_D, this.modalContext, this.dataChange).then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_WS_D:", response);
          this.loadingChange = false;
          this.setValueToReload = Math.floor(Math.random() * 100) - 110;
          $('#modalChangeWs').modal('toggle');

          ALERT_SERVICE.swal("Aviso", "Turno atualizado com sucesso.", "success");

        }).catch((reason) => {
          this.loadingChange = false;
          $('#modalChangeWs').modal('toggle');

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        if (!this.dataChange.remunerateType) {
          this.dataError.errorRemunerateType = "Campo obrigatório";
        }

        if (!this.dataChange.extraordinaryPhase) {
          this.dataError.errorExtraordinaryPhase = "Campo obrigatório";
        }

        if (!this.dataChange.toleranceType) {
          this.dataError.errorToleranceType = "Campo obrigatório";
        }
      }
    },
    changeMassWs() {
      const newWs = this.dataWorkshiftMass.workShifts.map((val) => {
        return {
          id: val.workShiftId,
          companyId: this.$route.params.idCompany,
          remunerateType: this.dataChange.remunerateType ? this.dataChange.remunerateTyp : val.remunerateType,
          extraordinaryPhase: this.dataChange.extraordinaryPhase ? this.dataChange.extraordinaryPhase : val.extraordinaryPhase,
          toleranceType: this.dataChange.toleranceType ? this.dataChange.toleranceType : val.toleranceType,
          ignoreMissingHoursOnFault: this.dataChange.ignoreMissingHoursOnFault ? this.dataChange.ignoreMissingHoursOnFault : val.ignoreMissingHoursOnFault,
        }
      })

      const URL = `${UPDATE_WS_D_MASS}?companyId=${this.$route.params.idCompany}`;
      this.loadingChange = true;
      UTIL_SERVICE.console("DATA SEND:", this.dataChange);
      REQUEST_SERVICE.requestContext('PUT', URL, this.dataWorkshiftMass.context, newWs).then((response) => {
        UTIL_SERVICE.console("RESULT UPDATE_WS_D:", response);
        this.loadingChange = false;
        this.setValueToReload = Math.floor(Math.random() * 100) - 110;
        $('#modalChangeWs').modal('toggle');

        ALERT_SERVICE.swal("Aviso", "Turno atualizado com sucesso.", "success");

      }).catch((reason) => {
        this.loadingChange = false;
        $('#modalChangeWs').modal('toggle');

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    handleChange() {
      if (this.$props.wsMass) {
        this.changeMassWs();
      } else {
        this.changeWs();
      }
    },
  },
}
</script>

<style lang="scss">
#modalChangeWs {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    line-height: 26px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .example-enum {
    p {
      display: inline-block;
      margin: 0 15px 5px 0;

      &:last-child {
        margin-bottom: 20px;
      }
    }
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeWorkShift.vue